import {getUserApiData} from "../../utils/UserUtils";
import {invokeApig} from "../../libs/awsLib";
import Paths from "../paths";

export function getCreatedProtocols({FarmID, ClientID, LocalUserID, forceFetch = false} = {}) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({FarmID, ClientID, LocalUserID});
    return invokeApig({
        ...Paths.getCreatedProtocols({farmID: _FarmID, clientID: _ClientID, localUserID: _LocalUserID}),
        forceFetch
    })
}
